import WhoIsDirectHedge from '../screens/static/WhoIsDirectHedge';
import Contact from '../screens/static/Contact';

let WhoIsDirectHedgePopup = {
    title: 'About Us',
    content: WhoIsDirectHedge(),
    large: true,
    buttonText: 'Ok'
}
let ContactPopup = {
    title: 'Contact Direct Hedge',
    content: Contact(),
    large: true,
    buttonText: 'Ok'
}

export let menuConfig = [
    {
        title: 'Register now',
        action: 'SHOW_USER_POPUP',
        requires: 'loggedout',
    },
    {
        title: 'Terms and conditions',
        path: 'termsAndConditions',
        requires: 'loggedin',
    },
    {
        title: 'About Us',
        action: 'SHOW_POPUP',
        addtionalProps: WhoIsDirectHedgePopup,
    },
    {
        title: 'Contact direct hedge',
        action: 'SHOW_POPUP',
        addtionalProps: ContactPopup
    }

];



// WEBPACK FOOTER //
// ./source/config/menutopconfig.js